import {
  type WorkerVisitLockResponse,
  workerVisitLockWorkerContract,
} from "@clipboard-health/contract-home-health-api";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

const { 200: workerVisitLockResponseSchema } =
  workerVisitLockWorkerContract.getWorkerVisitLock.responses;

function getWorkerVisitLockUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/visit-lock`;
}

export function getWorkerVisitLockQueryKey(workerId: string) {
  return [getWorkerVisitLockUrl(workerId)];
}

export function useGetWorkerVisitLockStatus(
  workerId: string,
  options?: UseGetQueryOptions<WorkerVisitLockResponse>
) {
  const url = getWorkerVisitLockUrl(workerId);

  return useGetQuery({
    url,
    responseSchema: workerVisitLockResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_VISIT_LOCK_STATUS_FAILURE,
    },
    enabled: isDefined(workerId),
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    ...options,
  });
}
